export const logDataHelperFunctions = {
  getIconForStatus: (status: string) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return '✅';
      case 'in progress':
        return '🔄';
      case 'not started':
        return '⏳';
      case 'rejected':
        return '❌';
      default:
        return '❓';
    }
  },

  formatWeldStartTime: (timestamp: string, format: string = '', includeTime: boolean = true) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(parseInt(timestamp) * 1000);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      if (includeTime) {
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHours = hours % 12 || 12;
        return `${day}-${month}-${year} ${displayHours}:${minutes} ${ampm}`;
      } else {
        return `${day}-${month}-${year}`;
      }
    } catch (error) {
      return timestamp;
    }
  },

  formatWeldDuration: (durationInMinutes: number) => {
    if (!durationInMinutes || durationInMinutes <= 0) return '-';
    
    const minutes = Math.floor(durationInMinutes);
    const seconds = Math.round((durationInMinutes - minutes) * 60);
    
    if (seconds === 0) {
      return `${minutes} min`;
    } else {
      return `${minutes} min ${seconds} sec`;
    }
  }
}; 